import { proNavigator } from "single-spa/react-app/ProNavigator";

export const isModuleSupportSegments = () => {
    const currentPageConfig = proNavigator.current();
    const getNearestStateWithIsModuleSupportSegments = proNavigator.getNearestStateWithHOF("isModuleSupportSegments");
    const state = getNearestStateWithIsModuleSupportSegments(currentPageConfig);
    return state && state.isModuleSupportSegments;
};
